
import { Component, Vue } from 'vue-property-decorator';
import Eleccion from '@/componentes/pago/Eleccion.vue';

const PropsEleccionModalidad = Vue.extend({
  props: {
    modalidad: {
      type: Number,
      default: null,
    },
  },
});

@Component({ components: { Eleccion } })
export default class EleccionModalidad extends PropsEleccionModalidad {
  get esMagister(): boolean {
    return this.$store.getters.esMagister;
  }

  get opcionesModalidad() {
    if (this.esMagister) {
      return [
        {
          nombre: 'Pago por Transferencia Bancaria',
          valor: 2,
          descripcion:
            'Se habilitará el pago mediante transferencia bancaria a la cuenta de la UAysén.',
          descripcion_bajada: 'Transferencia Bancaria',
        },
        {
          nombre: 'Modalidad Remota',
          valor: 1,
          descripcion: 'Continuarás por este sistema virtual, optando a:',
          descripcion_bajada: 'Webpay Plus',
        },
      ];
    }

    return [
      {
        nombre: 'Modalidad Presencial',
        valor: 2,
        descripcion:
          'Se habilitará el pago por caja en el Campus Lillo 1 de la UAysén, optando a:',
        descripcion_bajada: 'Pago Efectivo / Pago con cheques / Pago con tarjetas',
      },
      {
        nombre: 'Modalidad Remota',
        valor: 1,
        descripcion: 'Continuarás por este sistema virtual, optando a:',
        descripcion_bajada: 'Webpay Plus',
      },
    ];
  }
}
